<script>
export default {
  name: 'CtaSubmissionInformation',

  props: {
    submission: Object,
  },

  methods: {
    openSubmissionModal() {
      this.$root.openSubmissionModal({
        submission: this.submission,
      })
    },
  },
}
</script>

<template>
  <button
    class="btn mx-auto flex w-auto items-center justify-end border border-primary bg-white text-xs font-semibold text-primary md:justify-start"
    @click="openSubmissionModal">
    <eye class="mr-2 h-auto w-6 text-primary"></eye>
    {{ $t('account.contacts.seeMore') }}
  </button>
</template>
